import { createReducer } from '@reduxjs/toolkit'
import types from './types'
import { get, transform, keyBy } from 'lodash'

export { default as actions } from './actions'

const createFeatureMap = (features) => {
  const map = keyBy(features, 'Name')
  return transform(map, (result, feature, key) => {
    result[key] = feature.Enabled
  })
}

export const selectFeatures = (store) => get(store, `features.record`)

export default createReducer(
  {},
  {
    [types.FETCH_FEATURE_TOGGLES_SUCCESS]: (state, action) => {
      state.record = createFeatureMap(action.payload)
    },
  },
)

export const isFeatureEnabled = (store, name) => !!get(store, `features.record.${name}`)

export const selectCanApplicationInsightsSort = (store) => {
  return isFeatureEnabled(store, 'ApplicationInsightsSort')
}

export const selectAppRoundEditDisabled = (store) => {
  return isFeatureEnabled(store, 'DisableAppRoundEdits')
}

export const isGoogleMapsFeatureEnabled = (store) => {
  return isFeatureEnabled(store, 'EnableGoogleMaps')
}

export const isCollegeUpdateRequestEnabled = (store) => {
  return isFeatureEnabled(store, 'AllowCollegeUpdateRequests')
}

export const isDisplayParentYearMetricsEnabled = (store) => {
  return isFeatureEnabled(store, 'displayParentYearMetrics')
}

export const isTnTSearchFilterEnabled = (store) => {
  return isFeatureEnabled(store, 'TnTSearchFilter')
}

export const isHighSchoolExplorerEnabled = (store) => {
  return isFeatureEnabled(store, 'HighSchoolExplorer')
}
